import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import { resolveCatalogContext, buildCatalogPath } from "../utils/catalogContext";

const GuestVerify = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const params = useParams();

  // Usa o clientHash/sellerId da própria URL (login/cadastro com o catálogo
  // explícito) quando disponível, em vez de confiar cegamente no que ficou
  // salvo no localStorage de uma visita anterior a outro catálogo.
  const { clientHash, sellerId } = resolveCatalogContext(params);

  useEffect(() => {
    if (user) {
      navigate(buildCatalogPath(clientHash, sellerId), { replace: true });
    }
  }, [user, navigate, clientHash, sellerId]);

  return null;
};

export default GuestVerify;
